import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {ToolsService} from '../../../../../../services/tools.service';
import {CareproviderUnitService} from '../../../../../../services/careprovider-unit.service';
import {EventActionEnum, EventCategoryEnum} from '../../../../../../enums/GaTrackingEnums';
import {DLPageTypeEnum} from '../../../../../../enums/DataLayerEnums';
import {ImageWithCaption} from '../../../../../../types/ImageWithCaption';
import {ModalCommand} from '../../../../../../types/ModalCommand';
import {ModalTypeEnum} from '../../../../../../enums/ModalEnums';
import {ModalsControlService} from '../../../../../../services/modals-control.service';
import {UrlBuilderService} from '../../../../../../services/url-builder.service';

@Component({
  selector: 'app-cpru-top-info-img-section',
  templateUrl: './cpru-top-info-img-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block order-1 w-full lg:order-2 lg:grow-0 lg:shrink-0 lg:basis-[23.5rem]',
  },
})
export class CpruTopInfoImgSectionComponent {
  public pageType = input<DLPageTypeEnum>(null);
  protected readonly eventCategoryEnum = EventCategoryEnum;
  protected readonly eventActionEnum = EventActionEnum;
  protected readonly dLPageTypeEnum = DLPageTypeEnum;
  protected careProviderUnitUrl = computed<string[]>(() =>
    this.urlBuilder.CreateCareproviderUnitRouterLink(this.careproviderUnit()?.id, this.careproviderUnit()?.urlPath),
  );
  private careproviderUnitService = inject(CareproviderUnitService);
  protected careproviderUnit = this.careproviderUnitService.careproviderUnit;
  protected mainImage = computed<string>(() => {
    if (!this.careproviderUnit().caregiverUnitImages || !this.careproviderUnit().caregiverUnitImages.thumbnailUrl) {
      return null;
    }
    return this.tools.getImageUrl(this.careproviderUnit().caregiverUnitImages.thumbnailUrl);
  });
  public mainSegment = computed<string>(() =>
    this.careproviderUnit()?.mainCaregiverUnitType?.segment?.name?.toLowerCase(),
  );
  public logoUrl = computed<string>(() => {
    if (!this.careproviderUnit().caregiverUnitImages || !this.careproviderUnit().caregiverUnitImages.logoUrl) {
      return null;
    }
    return this.tools.getImageUrl(this.careproviderUnit().caregiverUnitImages.logoUrl);
  });
  public images = computed<ImageWithCaption[]>(() => {
    const images: ImageWithCaption[] = [];

    if (
      !this.tools.isNil(this.careproviderUnit().caregiverUnitImages) &&
      !this.tools.isNil(this.careproviderUnit().caregiverUnitImages.images)
    ) {
      if (images.length === 0) {
        this.careproviderUnit().caregiverUnitImages.images.forEach((item) => {
          item.url = this.tools.getImageUrl(item.url);
          images.push(item);
        });
      }
    }
    return images;
  });
  protected featureLabel = this.careproviderUnitService.featureLabel;
  protected address = this.careproviderUnitService.address;
  protected displayBookingBtn = this.careproviderUnitService.displayBookingBtn;
  protected bookingConfigurationData = this.careproviderUnitService.bookingConfigurationData;
  protected isHsa = this.careproviderUnitService.isHsa;
  protected isInternal = computed<boolean>(() =>
    this.careproviderUnitService.isInternalCareService(null, this.careproviderUnit()?.bookingSettings),
  );

  constructor(
    private tools: ToolsService,
    private modalsControlService: ModalsControlService,
    private urlBuilder: UrlBuilderService,
  ) {}

  public openImageGallery() {
    if (this.images().length > 1) {
      const modalCommand: ModalCommand = {
        type: ModalTypeEnum.GALLERY,
        data: {
          images: this.images(),
        },
      };
      this.modalsControlService.openModal(modalCommand);
    }
  }
}
